import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { selectedLangSelector } from "../../services/i18n/redux/selectors";
import { setSelectedLang } from "../../services/i18n/redux/slice";
import type { Language } from "../../services/i18n/redux/types";
import { LANGUAGE_KEY } from "../../services/i18n/redux/types";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { AppSelect } from "../../shared/components/AppSelect";
import { AppSelectOption } from "../../shared/components/AppSelect/AppSelectOption";
import styles from "./styles.module.css";

export const LanguageSelect = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const lngSelectOptions = [
    {
      label: "Русский",
      value: "ru",
    },
    {
      label: "English",
      value: "en",
    },
    {
      label: "հայկ",
      value: "hy",
    },
  ];

  const selectedLang = useAppSelector(selectedLangSelector);
  const dispatch = useAppDispatch();

  const changeLang = (e: any) => {
    if (location.pathname === "/telegramm_bots") {
      window.location.reload();
    }
    dispatch(setSelectedLang(e.target.value as Language));
    i18n.changeLanguage(e.target.value);
    localStorage.setItem(LANGUAGE_KEY, e.target.value);
  };

  return (
    <AppSelect
      className={styles.select}
      displayEmpty
      renderValue={() => {
        return (
          <span>
            {
              lngSelectOptions.find((item) => item.value === selectedLang)
                ?.label
            }
          </span>
        );
      }}
      value={selectedLang}
      onChange={changeLang}
    >
      {lngSelectOptions.map((lang) => (
        <AppSelectOption key={lang.value} value={lang.value}>
          {lang.label}
        </AppSelectOption>
      ))}
    </AppSelect>
  );
};
